export type HeaderElementDisplay = 'hidden' | 'main_pages' | 'all_pages';

export const HEADER_MAIN_PAGES = ['gatewaysPage', 'amountPage', 'paymentPage'];

export const NO_PAYMENT_METHODS_PAGE = 'noPaymentMethodsPage';

export const HEADER_SECONDARY_PAGES = [
  'errorPage',
  'redirectPage',
  'redirectEmbeddedPage',
  NO_PAYMENT_METHODS_PAGE,
];

export interface BalanceDisplayInput {
  balanceDisplay?: unknown;
  showBalance?: boolean | null;
  layout?: string | null;
}

export interface HeaderElementVisibilityInput {
  display: HeaderElementDisplay;
  currentPage?: string | null;
  isSecondaryStep?: boolean;
}

const isHeaderElementDisplay = (value: unknown): value is HeaderElementDisplay =>
  value === 'hidden' || value === 'main_pages' || value === 'all_pages';

const isUnresolvedPage = (currentPage?: string | null): boolean => currentPage == null;

const isMainPage = (currentPage?: string | null): boolean =>
  currentPage != null && HEADER_MAIN_PAGES.includes(currentPage);

const isSecondaryPage = (currentPage?: string | null): boolean =>
  currentPage != null && HEADER_SECONDARY_PAGES.includes(currentPage);

export const resolvePaymentTypeDisplay = (value: unknown): HeaderElementDisplay =>
  isHeaderElementDisplay(value) ? value : 'hidden';

export const resolveBalanceDisplay = ({
  balanceDisplay,
  showBalance,
  layout,
}: BalanceDisplayInput): HeaderElementDisplay => {
  if (isHeaderElementDisplay(balanceDisplay)) return balanceDisplay;
  const legacyShowBalance = showBalance ?? layout === 'amount-first';
  return legacyShowBalance ? 'main_pages' : 'hidden';
};

export const isHeaderElementVisible = ({
  display,
  currentPage,
  isSecondaryStep = false,
}: HeaderElementVisibilityInput): boolean => {
  if (display === 'hidden') return false;
  if (display === 'all_pages') {
    return isUnresolvedPage(currentPage) || isMainPage(currentPage) || isSecondaryPage(currentPage);
  }
  return isMainPage(currentPage) && !isSecondaryStep;
};
